import { ValueFormatterParams } from '@/grid/types';
import { CLINIC_RANCH_HAUL_IN_OPTIONS } from '@/pages/donor-scheduling-partnership/constants';
import { DonorSchedule } from '@/rtk-query.gql';

export const clinicRanchHaulinFormatter = (
  params: ValueFormatterParams<DonorSchedule, string | undefined>,
): string => {
  const crh = CLINIC_RANCH_HAUL_IN_OPTIONS.find(
    (x) => x.value === params.data?.clinicRanchHaulIn,
  );
  return crh?.name ?? '';
};
